/**
 * Created by mestrad on 2018. 06. 28..
 */

export default Person;

import Base from "./Base";
import TimeLine from "../../TimeLine";
import AutoComplete from "../../AutoComplete";

const $ = jQuery;

function Person(config) {
    Base.call(this, config);
    var self = this;
    var searchTimeLine;
    var placeholderList;
    var timeLineFilter = false;
    var filterCount = 0;
    var categoryList;
    var notAutoCompleteTypeList = [ "timeline" ];
    var nameSpaceConnectionTypeList = ["birth_place", "death_place"];
    /*
    var geoConnectionTypeList = ["birth_place", "death_place"];
     */
    var geoConnectionTypeList = [];

    function render(placeholders)
    {
        placeholderList = placeholders;
        addSearchTimeLine();
        initEvents();
    }

    function createFilter()
    {
        if($("#nnpSearchSelectContainer").length){
            self.addFilter(config.domElements.wrapperSelector, filterCount,
                self.getFilterTypes( categoryList, getExtraFilterTypes()),
                "#" + self.getSelectId( filterCount, "Types" ));
            var activeOption = self.getFilterTypes( categoryList, getExtraFilterTypes())[0].id;
            var newFilterId = "#" + self.getSelectId( filterCount, "Types" );
            initFilterEvents();
            var newWrapper = $(newFilterId).parent().find(".filterSelectWrapper");
            refreshFilterWrapper( newWrapper, activeOption );
            return;
        }
        filterCount = 0;
        var formCode = '<div id="nnpSearchSelectContainer">';
        self.getOptionList('category-types', function( categories ){
            categoryList = categories;
            var filterTypes = self.getFilterTypes( categories, getExtraFilterTypes() );
            formCode += self.createSelect( filterTypes, config.domElements.filterTypesId, config.domElements.filterTypesClass ) + '<div class="filterSelectWrapper">';
            placeholderList.$wrapperObj.html(formCode);
            checkSelectedOption();

            if(!timeLineFilter){
                var holderInput = self.createAutoCompleteInput( config.domElements.filterOptionsId + "helper" );
                formCode += holderInput + self.createRelationSelect( filterCount ) + '</div>';
            } else {
                var dateIntervall = self.createDateIntervall( config );
                formCode += dateIntervall.code;
            }

            formCode += self.createAddAndRemoveBtn() + '</div>';
            placeholderList.$wrapperObj.html(formCode);
            if(dateIntervall) {
                dateIntervall.initDatepicker();
                searchTimeLine.refresh();
                setTimeout(function(){
                    searchTimeLine.addFilterCustomTime( new Date("1900-01-01"), Date.now() );
                }, 1000);
            }
            if( $.inArray(filterTypes[0].id, notAutoCompleteTypeList) === -1 ){
                AutoComplete({
                    holderItem: "#" + config.domElements.filterOptionsId + "helper",
                    ajaxUrl: config.ajaxUrl,
                    objectType: geoConnectionTypeList.indexOf(filterTypes[0].id) > -1 ? "geo" : "person",
                    locale: config.locale,
                    type: nameSpaceConnectionTypeList.indexOf(filterTypes[0].id) > -1 ? "search" : "category-types",
                    categoryType: filterTypes[0].id,
                });
            }
            initFilterEvents();
        });
    }

    function getExtraFilterTypes()
    {
        var extraFilters = [];
        if(!timeLineFilter){
            extraFilters.push({
                    'title': 'Születés és elhalálozás ideje',
                    'id': 'timeline'
                });
        }
        extraFilters.push({
                "title": "Születés helye",
                "id": "birth_place"
            },
            {
                "title": "Halál helye",
                "id": "death_place"
            });
        return extraFilters;
    }

    function addSearchTimeLine()
    {
        if(searchTimeLine == undefined){
            searchTimeLine = new TimeLine({
                locale: config.locale,
                objectType: config.objectType,
                type: "search",
                selectors: {
                    elementId: placeholderList.$searchTimeLine[0].timeLineSelector,
                    zoomInId: placeholderList.$searchTimeLine[0].zoomInSelector,
                    zoomOutId: placeholderList.$searchTimeLine[0].zoomOutSelector,
                    moveLeftId: placeholderList.$searchTimeLine[0].moveLeftSelector,
                    moveRightId: placeholderList.$searchTimeLine[0].moveRightSelector,
                },
                domElements: config.domElements,
            });
            searchTimeLine.refresh();
        }
    }

    function initEvents()
    {
        config.$baseForm.on("searchResultReceived", function(event, receivedData){
            searchTimeLine.refresh(prepareReceivedData(receivedData));
        });
        config.$baseForm.on("change", "#nnp_search_date_from, #nnp_search_date_to", function(){
            var dateFromPicker = $(config.domElements.searchDateFrom);
            var dateToPicker = $(config.domElements.searchDateTo);
            $(".nnpSearchDateIntervallContainer").children(".nnp_error_message").remove();
            if( dateFromPicker.datepicker("getDate") <  dateToPicker.datepicker("getDate") ){
                searchTimeLine.setFilterCustomTime(
                    dateFromPicker.datepicker("getDate"),
                    dateToPicker.datepicker("getDate")
                );
            } else {
                $(".nnpSearchDateIntervallContainer").append('<div class="nnp_error_message">A kezdő dátum nem lehet nagyobb a vég dátumnál.</div>');
                searchTimeLine.revertFilterDateIntervall();
            }
        });
    }

    function initFilterEvents()
    {
        var addBtn = $(".addFilterBtn");
        var removeBtn = $(".removeFilterBtn");
        var filterTypeSelect = $("#" + self.getSelectId( filterCount, "Types" ));
        addBtn.off("click");
        removeBtn.off("click");
        addBtn.on("click", function(){
            var activeOption = self.getFilterTypes( categoryList, getExtraFilterTypes())[0].id;
            var newFilterId = "#" + self.getSelectId( filterCount, "Types" );
            self.addFilter( config.domElements.wrapperSelector, filterCount,
                self.getFilterTypes( categoryList, getExtraFilterTypes()),
                newFilterId );
            initFilterEvents();
            var newWrapper = $(newFilterId).parent().find(".filterSelectWrapper");
            refreshFilterWrapper( newWrapper, activeOption );
        });
        removeBtn.on("click", function(){
            self.removeFilter( this );
            checkSelectedOption();
            if(!timeLineFilter) searchTimeLine.removeFilterCustomTime();
            self.refreshSearchWrapper(self.getFilterTypes( categoryList, getExtraFilterTypes()));
        });
        filterTypeSelect.on("change", function(){
            refreshAllSelectOptions( filterTypeSelect.val(), "#" + filterTypeSelect.attr("id"), filterTypeSelect.parent() );
        });
        filterCount++;
    }

    function refreshAllSelectOptions( value, selectId, parent )
    {
        refreshFilterWrapper( parent.find(".filterSelectWrapper"), value );
        self.refreshSearchWrapper( self.getFilterTypes( categoryList, getExtraFilterTypes()), selectId );
    }

    function refreshFilterWrapper( wrapper, value )
    {
        checkSelectedOption();
        if( $.inArray(value, notAutoCompleteTypeList) < 0 ){
            appendFilterInput( wrapper, value );
            // appendFilterSelect( wrapper, value );
        } else {
            if(value == "timeline"){
                wrapper.children().remove();
                var dateIntervall = self.createDateIntervall( config );
                wrapper.append(dateIntervall.code);
                dateIntervall.initDatepicker();
                searchTimeLine.refresh();
                setTimeout(function(){
                    searchTimeLine.addFilterCustomTime( new Date("1900-01-01"), Date.now() );
                }, 1000);
            } else {
                appendFilterInput( wrapper, value );
            }
        }
        if(!timeLineFilter){
            searchTimeLine.removeFilterCustomTime();
        }
    }

    function appendFilterInput( wrapper, value )
    {
        var helperArray = wrapper.prev().attr("id").split('_');
        var filterIndex = helperArray.length === 1 ? 0 : helperArray[helperArray.length -1];
        var filterTypes = self.getFilterTypes( categoryList, getExtraFilterTypes());
        filterTypes.forEach(function(item){
            if(item.id === value){
                var selectId = self.getSelectId( filterIndex, "Options" );
                var holderInput = self.createAutoCompleteInput( selectId + "helper" );
                wrapper.children().remove();
                wrapper.append( holderInput + self.createRelationSelect(filterCount-1 ));
                AutoComplete({
                    holderItem: "#" + selectId + "helper",
                    ajaxUrl: config.ajaxUrl,
                    objectType: geoConnectionTypeList.indexOf(item.id) > -1 ? "geo" : "person",
                    locale: config.locale,
                    type: nameSpaceConnectionTypeList.indexOf(item.id) > -1 ? "search" : "category-types",
                    categoryType: item.id,
                });
            }
        });
    }

    function appendFilterSelect( wrapper, value )
    {
        var filterTypes = self.getFilterTypes( categoryList, getExtraFilterTypes());
        filterTypes.forEach(function(item){
            if(item.id == value){
                var selectId = wrapper.children().attr("id") || self.getSelectId( filterCount-1, "Options" );
                wrapper.children().remove();
                wrapper.append(self.createSelect( self.getCategoryItems( value, categoryList ), selectId, config.domElements.filterOptionsClass ) +
                    self.createRelationSelect( filterCount-1 ));
            }
        });
    }

    function checkSelectedOption()
    {
        timeLineFilter = false;
        $("#customSearchWrapper select").each(function(){
            var item = $("#" + this.id);
            if(item.hasClass(config.domElements.filterTypesClass)){
                if(item.val() == "timeline"){
                    timeLineFilter = true;
                }
            }
        });
    }

    function prepareReceivedData(feed)
    {
        var data = [];
        if(feed === undefined) {
            return null;
        }

        feed.forEach(function(item, index){
            var activeItem;
            var birthDate;
            item.dataList.forEach(function(name){
                if(name.active == 1){
                    activeItem = name;
                }
            });
            if(activeItem == undefined) activeItem = item.nameList[0];

            item.dataList.forEach(element => {
                if(element.type === "birth_date") birthDate = element.value;
            });

            if(birthDate !== undefined){
              data[index] = {
                id: item.id,
                from: birthDate,
                content: activeItem.title
              }
            }
        });
        return data;
    }

    return {
        render: render,
        createFilter: createFilter
    };
}

Person.prototype = Object.create(Base.prototype);